/**
 * AppRoutes.jsx — Agrégateur de toutes les routes de la plateforme.
 *
 * Phase 30 (refonte back-office) : 4 back-offices distincts avec redirect
 * post-login selon le rôle utilisateur.
 *  - /eleve/*        (rôle eleve | admin)
 *  - /enseignant/*   (existant + shell BO à venir Phase 30b)
 *  - /secretariat/*  (rôle secretaire | admin)
 *  - /admin/*        (rôle admin uniquement)
 *
 * Legacy /bo/* → redirection intelligente vers les nouveaux back-offices.
 */
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { StudentRoutes } from './studentRoutes';
import { TeacherRoutes } from './teacherRoutes';
import { AdminRoutes } from './adminRoutes';
import { B2BRoutes } from './b2bRoutes';
import { SecretariatRoutes } from './secretariatRoutes';
import { EleveRoutes } from './eleveRoutes';
import { MoniteurRoutes } from './moniteurRoutes';
import BoLegacyRedirect from '../pages/BoLegacyRedirect';
import B2BGate from '../pages/B2BGate';
import B2BDocumentView from '../pages/B2BDocumentView';
import VCardPage from '../pages/VCardPage';
import CVPage from '../pages/CVPage';
import PlaquetteProspects from '../pages/PlaquetteProspects';

export const AppRoutes = () => (
  <Routes>
    {StudentRoutes()}
    {TeacherRoutes()}
    {B2BRoutes()}
    {AdminRoutes()}
    {SecretariatRoutes()}
    {EleveRoutes()}
    {MoniteurRoutes()}
    {/* Porte d'entrée vers la plaquette B2B (invisible pour les élèves/visiteurs) */}
    <Route path="/b2b" element={<B2BGate />} />
    {/* Signature électronique partenaire — accessible via token UUID (lien partageable) */}
    <Route path="/b2b/doc/:token" element={<B2BDocumentView />} />
    {/* Carte de visite digitale — avec ou sans tracking prospect */}
    <Route path="/vcard" element={<VCardPage />} />
    <Route path="/vcard/:slug" element={<VCardPage />} />
    <Route path="/b" element={<VCardPage />} />
    <Route path="/b/:slug" element={<VCardPage />} />
    {/* CV interactif immersif */}
    <Route path="/cv" element={<CVPage />} />
    {/* Plaquette publique teaser (pour prospects, accessible depuis le QR Plaquette) */}
    <Route path="/plaquette-prospects" element={<PlaquetteProspects />} />
    <Route path="/plaquette" element={<PlaquetteProspects />} />
    {/* Legacy /bo/* → redirection intelligente vers les nouveaux back-offices par rôle */}
    <Route path="/bo" element={<BoLegacyRedirect />} />
    <Route path="/bo/*" element={<BoLegacyRedirect />} />
    {/* Fallback global */}
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default AppRoutes;
